module.exports = __webpack_public_path__ + "img/gzh.c3302322.png";